import { LATEST_SLIDES, LATEST_VERSION } from './latest';

// Map of versions for which we have released WhatsNewSlides
// Insert new versions at the start of the map!
const WHATS_NEW_MAP = new Map([[LATEST_VERSION, LATEST_SLIDES]]);

export { WHATS_NEW_MAP };
